export const DUPLICATED = "duplicated";
export const NOTFOUND = "not_found";
export const INVALID_INPUT_DATA = "input_invalid";
